import { Box, ListItem } from '@chakra-ui/react';
import { ListView } from 'components/molecules/ListView';
import { FC } from 'react';
import { useListStore } from '../../hooks';
import { EnvironmentListHeader } from './EnvironmentListHeader';
import { EnvironmentListItem } from './EnvironmentListItem';

type UseListStoreReturnType = ReturnType<typeof useListStore>;

type Props = {
  listItems: UseListStoreReturnType['releaseEnvironments'];
  handleEditOpenModal: UseListStoreReturnType['onOpenModal'];
  componentList: { id: number | undefined; componentName: string }[];
};

export const EnvironmentListView: FC<Props> = ({
  listItems,
  handleEditOpenModal,
  componentList,
}) => (
  <>
    <Box m="20px 0 0 0">
      <EnvironmentListHeader />
    </Box>
    <ListView>
      {listItems.map((item, index) => (
        <ListItem key={index.toString()} listStyleType="none">
          <EnvironmentListItem
            item={item}
            handleClickRow={() => handleEditOpenModal(item)}
            componentList={componentList}
          />
        </ListItem>
      ))}
    </ListView>
  </>
);
